import { FC } from "react";
import DocManagerSvg from "../../public/icons/DocManager.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const DocManagerIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><DocManagerSvg/></span>;
